export default async function logout({ next, store }) {
  await store.dispatch('logout');
  return next({
    name: 'Login',
  });
}
